import React, { useState } from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import { LegalModal, LegalType } from './LegalModal';
export function Footer() {
  const [legal, setLegal] = useState<LegalType | null>(null);
  return <footer className="bg-dark-200 pt-16 pb-8 border-t border-white/10" data-id="element-83" data-mp="32ovvqqc38li1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84" data-mp="36oxyz3xh1mzf">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-85" data-mp="36nd6rkymqg4q">
          <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt="AS Elite Contractor Logo" className="h-20 md:h-24 w-auto object-contain mb-4" data-id="element-86" data-mp="3ufjvpz20zku4" />
          <p className="text-gold font-medium tracking-widest uppercase text-sm" data-id="element-87" data-mp="3qdf2v2jeis8j">
            Construido Para Contractors Serios
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12 border-y border-white/10 py-8" data-id="element-88" data-mp="29xlzel58oyhi">
          <a href="#servicios" className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-89" data-mp="2ezuvvrhbmiod">
            Servicios
          </a>
          <a href="#portafolio" className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-90" data-mp="3gca6z6kkzzcs">
            Portafolio
          </a>
          <a href="#nosotros" className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-91" data-mp="3qapyvbrfncnc">
            Nosotros
          </a>
          <a href="#resenas" className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-92" data-mp="31umvaqetzm7">
            Reseñas
          </a>
          <a href="https://wa.me/447311754270?text=WEBSITE" className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-93" data-mp="cw3595lq8c6n">
            Contacto
          </a>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-94" data-mp="tw5wk16p5gk3">
          <div className="flex gap-4" data-id="element-95" data-mp="yuzdk3l6zpp0">
            <button onClick={() => setLegal('privacy')} className="hover:text-white transition-colors" data-id="element-96" data-mp="yruyuca3pbk3">
              Política de Privacidad
            </button>
            <span data-id="element-97" data-mp="1clmc9vqydfl3">|</span>
            <button onClick={() => setLegal('terms')} className="hover:text-white transition-colors" data-id="element-98" data-mp="1cm47qq5sjpry">
              Términos de Servicio
            </button>
          </div>

          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-99" data-mp="1mktq0k1lnc8q">
            <div className="flex items-center gap-2" data-id="element-100" data-mp="1rjeqmkkrjxxp">
              <MessageCircle className="w-4 h-4 text-white" data-id="element-101" data-mp="1ri3jcas4081u" />
              <span className="text-white font-bold" data-id="element-102" data-mp="3oc6s71c6n613">WhatsApp:</span>
              <a href="https://wa.me/447311754270?text=WEBSITE" className="text-gold hover:text-gold-400 transition-colors" data-id="element-103" data-mp="3t9yixs13cm3p">
                +44 7311 754270
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-104" data-mp="25nlpuwlfwsw0">
              <Mail className="w-4 h-4 text-white" data-id="element-105" data-mp="21mti67s7uw1u" />
              <span className="text-white font-bold" data-id="element-106" data-mp="21nbl1n9dw8iq">Email:</span>
              <a href="mailto:aselitecontractor@gmail.com" className="text-gold hover:text-gold-400 transition-colors" data-id="element-107" data-mp="1wo8o6q3k58lu">
                aselitecontractor@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-108" data-mp="2pd5v5x2bjiza">
              <svg viewBox="0 0 24 24" className="w-4 h-4 text-white fill-current" aria-hidden="true" data-id="element-109" data-mp="2kci8fnl4hoav">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-110" data-mp="2fgku1mtf6s0q" />
              </svg>
              <span className="text-white font-bold" data-id="element-111" data-mp="2wmg00xmpfrg2">TikTok:</span>
              <a href="https://www.tiktok.com/@aselitecontractor" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-400 transition-colors" data-id="element-112" data-mp="2wnr1urwlap4j">
                @aselitecontractor
              </a>
            </div>
          </div>

          <div data-id="element-113" data-mp="3flbvecaaubvh">© 2024 AS Elite Contractor. Todos los Derechos Reservados.</div>
        </div>
      </div>

      <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-114" data-mp="31lsvu7vk08us" />
    </footer>;
}